<template>
  <section class="third-party-auth">
    <div class="layout system-setting-layout">
      <div class="system-setting">
        <div class="layout-header regional-header" ref="searchBox">
          <div class="infor-layout-header">
            <span class="title">第三方数据授权</span>
              <el-button
                v-show="checkUserAuth(6, 240)"
                type="primary"
                size="small"
                style="background-color: #3e7878;border-color: #3e7878"
                @click="onAdd">
                添加账号
              </el-button>
          </div>
          <el-form
            ref="formRef"
            :inline="true"
            class="demo-form-inline"
            :model="form"
            size="small">
            <el-form-item label="用户账号">
              <el-input v-model.trim="form.userAccount" style="width: 150px"/>
            </el-form-item>
            <el-form-item label="联系人">
              <el-input v-model.trim="form.contactPerson" style="width: 150px"/>
            </el-form-item>
            <el-form-item label="联系电话">
              <el-input v-model.trim="form.contactPhone" style="width: 150px"/>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearch">查询</el-button>
              <el-button @click="onReset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div style="height: 9rem"></div>
        <div class="regional_table">
          <el-table
            v-show="checkUserAuth(6, 241)"
            v-loading.body="tableLoading"
            :height="tableViewHeight"
            :data="tableData"
            width="100%"
            highlight-current-row>
            <el-table-column prop="index" label="序号" align="center">
              <template v-slot="props">
                <span>{{ props.$index + 1 + (formData.pageNum - 1) * formData.pageSize }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="contactPerson" label="联系人" align="center">
              <template v-slot="props">
                 <span
                   @click="onShowDialog(props.row)"
                   class="cursor"
                   style="text-decoration: underline">
                  {{ props.row.contactPerson }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="contactPhone" label="联系电话" align="center"></el-table-column>
            <el-table-column prop="workUnit" label="工作单位" align="center"></el-table-column>
            <el-table-column prop="unavailableTime" label="授权截止时间" sortable>
              <template v-slot="props">
                <span>{{ props.row.unavailableTime | dateFormat('yyyy-MM-dd hh:mm:ss') }}</span>
              </template>
            </el-table-column>                                                                                                                                                         align="center"></el-table-column>
            <el-table-column prop="unavailableTime" label="创建时间" sortable>
              <template v-slot="props">
                <span>{{ props.row.createTime | dateFormat('yyyy-MM-dd hh:mm:ss') }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template v-slot="props">
                <span v-show="checkUserAuth(6, 240)" style="color: #1ca0ff;cursor: pointer;" @click="onEdit(props.row)">编辑</span>
              </template>
          </el-table-column>
          </el-table>
          <el-pagination
            v-show="checkUserAuth(6, 241)"
            style="margin-top: 15px; text-align: right"
            @size-change="handleSizeChange"
            @current-change="pageNoChange"
            :current-page="formData.pageNum"
            :page-sizes="pageSizes"
            :page-size="formData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
          <div style="line-height: 50px;margin-left: 10px;" v-show="!checkUserAuth(6, 241)">您的账户没有权限查看此内容！</div>
        </div>
      </div>
      <w-dialog
        width="40%"
        ref="auth-account"
        title="添加账号"
        sureBtnText="添加"
        @handleCloseRight="handleCloseAuthLog"
        @handleClose="handleCloseAuthLog"
        @onSure="onSaveAuthAccount">
        <template v-slot:content>
          <el-form :rules="rules" ref="ruleForm" :model="formDialog" label-width="6.25rem" size="small">
            <el-form-item label="联系人：" prop="contactPerson">
              <el-input v-model.trim="formDialog.contactPerson" clearable placeholder="请填写" style="width:40%;"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="contactPhone">
              <el-input v-model.trim="formDialog.contactPhone" clearable placeholder="请填写" maxlength="11" style="width:40%;"></el-input>
            </el-form-item>
            <el-form-item label="工作单位：" prop="workUnit">
              <el-input v-model.trim="formDialog.workUnit" clearable placeholder="请填写" style="width:40%;"></el-input>
            </el-form-item>
            <el-form-item label="授权时效：" prop="unavailableTime">
              <el-date-picker
                style="width:40%;"
                v-model="formDialog.unavailableTime"
                type="datetime"
                placeholder="选择截止日期"
                default-time="23:59:59">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="授权区域：" prop="authArea">
              <div>
                <el-select
                  v-model="formDialog.authProvinceId"
                  placeholder="请选择省份"
                  size="small"
                  @change="onChangeProvince"
                  style="margin-right:10px;width:25%;">
                  <el-option
                    v-for="item in provinceOptions"
                    :key="item.id"
                    :label="item.areaName"
                    :value="item.id">
                  </el-option>
                </el-select>
                <el-select
                  v-model="formDialog.authCityId"
                  :disabled="cityDisable"
                  placeholder="请选择城市"
                  size="small"
                  @change="onChangeCity"
                  style="margin-right:10px;width:25%;">
                  <el-option
                    v-for="item in cityOptions"
                    :key="'2'+item.id"
                    :label="item.areaName"
                    :value="item.id">
                  </el-option>
                </el-select>
                <el-cascader
                  v-model="formDialog.authRegionIds"
                  :disabled="regionDisable"
                  :options="regionOptions"
                  :props="{
                    value: 'id',
                    label: 'areaName',
                    children: 'child',
                    multiple: true,
                    checkStrictly: true}"
                  placeholder="请选择县区"
                  collapse-tags
                  clearable>
                </el-cascader>
              </div>
            </el-form-item>
          </el-form>
        </template>
      </w-dialog>
      <el-dialog title="查看账号" :visible.sync="dialogVisible"
                 :modal="false"
                 :close-on-click-modal="false"
                 width="20%">
        <div class="info-line">
          <span class="label">联系人：</span>
          <span class="value">{{detail.contactPerson}}</span>
        </div>
        <div class="info-line">
          <span class="label">用户账号：</span>
          <span class="value">{{detail.userAccount}}</span>
        </div>
        <div class="info-line">
          <span class="label">随机密码：</span>
          <span class="value">{{ detail.randomPassword }}</span>
        </div>
        <div class="info-line">
          <span class="label">联系电话：</span>
          <span class="value">{{ detail.contactPhone }}</span>
        </div>
      </el-dialog>
    </div>
  </section>
</template>
<script>

import Api from '@/api'
import { mapGetters } from 'vuex'
import WDialog from '@/components/Model/index.vue'

export default {
  name: 'thirdPartyAuth',
  components: { WDialog },
  data() {
    return {
      form: {
        userAccount: '',
        contactPerson: '',
        contactPhone: ''
      },
      tableLoading: true,
      tableData: [],
      formData: {
        pageNum: 1,
        pageSize: 20
      },
      pageSizes: [10, 20, 50],
      total: 0,
      tableViewHeight: 50,
      formDialog: {},
      originalPhone: '',
      cityDisable: true,
      regionDisable: true,
      rules: {
        contactPerson: [
          { required: true, message: '请填写联系人', trigger: 'blur' },
          { validator: this.validateChineseName, trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请填写联系电话', trigger: 'blur' },
          { min: 8, message: '长度至少8个字符', trigger: 'blur' },
          {
            pattern: '^1[3456789]\\d{9}$',
            message: '手机号格式不正确',
            trigger: 'blur'
          },
          { validator: this.validatePhone, trigger: 'change' }
        ],
        workUnit: [
          { required: true, message: '请填写工作单位', trigger: 'blur' },
          { min: 2, message: '长度至少2个字符', trigger: 'blur' },
          { validator: this.validateChineseWorkUnit, trigger: 'blur' }
        ],
        unavailableTime: [
          { required: true, message: '请选择截止日期', trigger: 'blur' }
        ],
        authArea: [{ validator: this.validateArea, trigger: 'change' }]
      },
      provinceOptions: [],
      cityOptions: [],
      regionOptions: [],
      dialogVisible: false,
      detail: {},
      saveStatus: 'add'
    }
  },
  computed: {
    ...mapGetters(['user', 'selfAreaId', 'userLevel'])
  },
  created() {
    this.onSearch()
  },
  methods: {
    // 事件处理区
    onAdd() {
      this.saveStatus = 'add'
      if (this.userLevel !== 1) {
        this.$message.warning('请选择对应城市！')
        return false
      }
      this.formDialog = {}
      this.cityDisable = true
      this.regionDisable = true
      this.initProvince()
      this.initArea()
      this.$refs['auth-account'].onShowDialog()
    },
    initProvince() {
      const params = {
        selfAreaId: this.selfAreaId,
        areaId: this.selfAreaId
      }
      Api.getUserArea2(params)
        .then(res => {
          if (res.code === 200) {
            this.provinceOptions = res.data
            this.cityOptions = res.data[0].child
          }
        })
    },
    initArea() {
      const params = {
        selfAreaId: this.formDialog.authCityId
      }
      Api.getCityAreaByChild(params)
        .then(res => {
          if (res.code === 200) {
            this.regionOptions = res.data
          }
        })
    },
    onChangeProvince(item) {
      this.cityDisable = false
    },
    onChangeCity(item) {
      this.regionDisable = false
    },
    onSearch() {
      const params = {
        selfAreaId: this.selfAreaId,
        currentPage: this.formData.pageNum,
        pageSize: this.formData.pageSize,
        userAccount: this.form.userAccount,
        contactPerson: this.form.contactPerson,
        contactPhone: this.form.contactPhone,
        authCityId: this.selfAreaId
      }
      Api.getThirdPartyAuthList(params).then((res) => {
        this.tableLoading = false
        if (res.code === 200 && res.data) {
          this.tableData = res.data.lists
          this.total = res.data.total
        } else {
          this.$message.warning(res.message)
        }
        this.calcView()
      })
    },
    pageNoChange(page) {
      this.formData.pageNum = page
      this.onSearch()
    },
    handleSizeChange(size) {
      this.formData.pageSize = size
      this.onSearch()
    },
    onEdit(row) {
      this.saveStatus = 'edit'
      this.formDialog = { ...row }
      this.formDialog.authRegionIds = JSON.parse(this.formDialog.authRegionIds)
      // 记录原始手机号
      this.originalPhone = row.contactPhone
      this.initProvince()
      this.initArea()
      this.cityDisable = false
      this.regionDisable = false
      this.$refs['auth-account'].onShowDialog()
    },
    onReset() {
      this.$refs.formRef.resetFields()
      this.form.userAccount = ''
      this.form.contactPerson = ''
      this.form.contactPhone = ''
      this.onSearch()
    },
    onSaveAuthAccount() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = {}
          params = { ...this.formDialog }
          params.authRegionIds = JSON.stringify(this.formDialog.authRegionIds)
          params.authRegionId = this.getAuthRegionId(this.formDialog.authRegionIds)
          if (this.saveStatus === 'add') {
            // 新增
            params.createBy = this.user.id
          } else {
            // 修改
            params.updateBy = this.user.id
          }
          Api.saveThirdPartyAuthUser(this.selfAreaId, params).then(res => {
            if (res.code === 200) {
              this.onSearch()
              this.handleCloseAuthLog()
              this.$message.success(this.saveStatus === 'add' ? '新增成功' : '修改成功')
            } else {
              this.$message.warning(res && res.message)
            }
          })
        }
      })
    },
    getAuthRegionId(authRegionIds) {
      // 处理authRegionId，将多维数组转为一维数组并去重
      const flatRegionIds = []
      if (authRegionIds && authRegionIds.length) {
        authRegionIds.forEach(region => {
          // 如果是数组则展开，否则直接添加
          if (Array.isArray(region)) {
            flatRegionIds.push(...region)
          } else {
            flatRegionIds.push(region)
          }
        })
        // 去重处理
        const arr = [...new Set(flatRegionIds)]
        // 数组转为字符串（以逗号分隔）
        const result = arr.join("', '")
        const finalResult = "'" + result + "'"
        return finalResult
      }
    },
    handleCloseAuthLog() {
      this.$refs['auth-account'].onCloseDialog()
    },
    validateChineseName(rule, value, callback) {
      const chineseRegex = /^[\u4e00-\u9fa5]+$/
      if (value.length < 2) {
        callback(new Error('姓名必须中文并不少于2个字符'))
        return
      }
      // 检查是否全是中文
      if (!chineseRegex.test(value)) {
        callback(new Error('姓名必须为中文'))
        return
      }
      callback()
    },
    validatePhone(rule, value, callback) {
      const vm = this
      // 关键：如果是修改状态且手机号未发生变化，直接通过验证
      if (vm.saveStatus === 'edit' && value === vm.originalPhone) {
        callback()
        return
      }
      const params = {
        selfAreaId: vm.selfAreaId,
        authCityId: vm.selfAreaId,
        contactPhone: vm.formDialog.contactPhone
      }
      Api.checkAuthPhone(params)
        .then(res => {
          if (res.code === 200) {
            if (Number(res.data.existPhone) === 0) {
              callback()
            } else {
              callback(new Error('该联系电话已被注册，请重新输入！'))
            }
          } else {
            vm.$message.warning(res.message)
          }
        })
    },
    validateChineseWorkUnit(rule, value, callback) {
      const chineseRegex = /^[\u4e00-\u9fa5]+$/
      // 检查是否全是中文
      if (!chineseRegex.test(value)) {
        callback(new Error('工作单位必须为中文'))
        return
      }
      callback()
    },
    validateArea(rule, value, callback) {
      if (!this.formDialog.authProvinceId) {
        callback(new Error('请先选择省份'))
      } else if (!this.formDialog.authCityId) {
        callback(new Error('请选择城市'))
      } else if (!this.formDialog.authRegionIds) {
        callback(new Error('请选择县区'))
      } else {
        callback()
      }
    },
    onShowDialog(row) {
      this.detail = { ...row }
      this.dialogVisible = true
    },
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        this.tableViewHeight = window.innerHeight - 56 - H - 96 - 56
      })
    }
  }
}
</script>

<style scoped lang="less">
.layout-header {
  padding: 0.8rem 1.5rem;
}
.layout-header.regional-header {
  box-sizing: border-box;
  margin: 0 10px 24px 10px;
}
.demo-form-inline{
  margin-top: 15px;
}
.regional_table {
  margin: 0 10px 24px 10px;
  padding-bottom: 10px;
  box-sizing: border-box;
  background-color: #fff;
}
.info-line {
  display: flex;
  align-items: center; /* 垂直居中 */
  margin-bottom: 15px; /* 每行之间的间距 */
  .label {
    min-width: 120px; /* 根据需要设置标签的最小宽度 */
    text-align: right; /* 标签文本右对齐（但冒号会保持在左边，因为冒号是标签的一部分） */
    padding-right: 15px; /* 标签和值之间的间距 */
    box-sizing: border-box; /* 确保padding不会增加元素的总宽度 */
  }
  .value {
    flex-grow: 1; /* 值占据剩余的空间 */
    word-break: break-all; /* 确保长文本不会溢出容器 */
  }
}

</style>
